export enum PersistAppReduxActions {
    PERSIST_APP_SET_PACKET_ROWSPERPAGE = 'PERSIST_APP_SET_PACKET_ROWSPERPAGE',
    PERSIST_APP_SET_HISTORY_ROWSPERPAGE = 'PERSIST_APP_SET_HISTORY_ROWSPERPAGE',
    PERSIST_APP_SET_ACCESS_ROWSPERPAGE = 'PERSIST_APP_SET_ACCESS_ROWSPERPAGE',
    PERSIST_APP_SET_CHECKLIST_ROWSPERPAGE = 'PERSIST_APP_SET_CHECKLIST_ROWSPERPAGE',
    PERSIST_APP_SET_RELOAD = 'PERSIST_APP_SET_RELOAD',
    PERSIST_APP_TABID = 'PERSIST_APP_TABID',
    PERSIST_APP_IDX = 'PERSIST_APP_IDX',
    PERSIST_APP_PREVIOUSLY_IDX = 'PERSIST_APP_PREVIOUSLY_IDX',
    PERSIST_LOCATION_CHANGE = '@@router/LOCATION_CHANGE',
}
export const setPacketRowsPerPageNumber = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_SET_PACKET_ROWSPERPAGE,
    payload,
});

export const setHistoryRowsPerPageNumber = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_SET_HISTORY_ROWSPERPAGE,
    payload,
});

export const setAccessRowsPerPageNumber = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_SET_ACCESS_ROWSPERPAGE,
    payload,
});

export const setChecklistRowsPerPageNumber = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_SET_CHECKLIST_ROWSPERPAGE,
    payload,
});

export const setRouteReloaded = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_SET_RELOAD,
    payload,
});

const SetRouteTabId = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_TABID,
    payload,
});
const SetAppIdx = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_IDX,
    payload,
});

const SetAppPreviouslyIdx = (payload: any): any => ({
    type: PersistAppReduxActions.PERSIST_APP_PREVIOUSLY_IDX,
    payload,
});

export const PersistAppActions = {
    setChecklistRowsPerPageNumber,
    setAccessRowsPerPageNumber,
    setHistoryRowsPerPageNumber,
    setPacketRowsPerPageNumber,
    setRouteReloaded,
    SetRouteTabId,
    SetAppPreviouslyIdx,
    SetAppIdx,
};
